import { OSF } from "../lib/osfmos";
import { OfficeExt } from "../lib/osfmos";
import { Constants } from "./constants";
import * as fs from "fs";
import { assert } from "console";

export class Utilities {
  static isNullOrUndefined(value: any): boolean {
    return value === null || value === undefined;
  }

  static writeFile(path: string, contents: string, errorText: string, successText: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      fs.writeFile(path, contents, (err) => {
        if (err) {
          Utilities.logError(errorText, err);
          reject(err);
        } else {
          Utilities.log(successText);
          resolve();
        }
      });
    });
  }

  static async writeFileSync(path: string, contents: string, successText: string) {
    await fs.writeFileSync(path, contents);

    Utilities.log(successText);
  }

  static ensureFolder(folderPath: string) {
    if (!fs.existsSync(folderPath)) {
      fs.mkdirSync(folderPath, { recursive: true });
    }
  }

  static _inputXmlFilePath: string = "";
  static setInputXmlFilePath(inputXmlFilePath: string) {
    Utilities._inputXmlFilePath = inputXmlFilePath;
  }

  static _showDebugInfo: boolean = false;
  static setShowDebugInfo(showDebugInfo: boolean) {
    Utilities._showDebugInfo = showDebugInfo;
  }

  static _verboseLogging: boolean = false;
  static setVerbosity(verbose: boolean) {
    Utilities._verboseLogging = verbose;
  }
  static getVerbosity(): boolean {
    return Utilities._verboseLogging;
  }

  static _downloadImages: boolean = false;
  static setDownloadImages(downloadImages: boolean) {
    Utilities._downloadImages = downloadImages;
  }

  static _writeImageUrls: boolean = false;
  static setWriteImageUrls(writeImageUrls: boolean) {
    Utilities._writeImageUrls = writeImageUrls;
  }

  static _schemaOverride: string = null;
  static setSchemaOverride(schemaOverride: string): void {
    Utilities._schemaOverride = schemaOverride;
  }

  static _schemaVersionOverride: string = null;
  static setSchemaVersionOverride(schemaVersionOverride: string): void {
    Utilities._schemaVersionOverride = schemaVersionOverride;
  }

  static log(message?: any, ...optionalParams): void {
    if (Utilities._verboseLogging) {
      console.log(Constants.LoggingPrefix + message, ...optionalParams);
    }
  }

  static logWarning(message?: any, ...optionalParams): void {
    if (Utilities._verboseLogging) {
      console.error(Constants.LoggingPrefixWarning + message, ...optionalParams);
    }
  }

  static logError(message?: any, ...optionalParams): void {
    if (Utilities._verboseLogging) {
      console.error(Constants.LoggingPrefixError + message, ...optionalParams);
    }
  }

  static logDebug(message?: any, ...optionalParams): void {
    if (Utilities._showDebugInfo) {
      console.log(Constants.LoggingPrefix + message, ...optionalParams);
    }
  }

  static assert(condition: boolean, message?: any, ...optionalParams): void {
    if (Utilities._showDebugInfo) {
      assert(condition, message, ...optionalParams);
    }
  }

  static createLocaleFileName(locale: string): string {
    return locale + Constants.JSONFileSuffix;
  }

  static truncateString(value: string, maxLength: number): string {
    if (value.length <= maxLength) {
      return value;
    }

    const insertLengths: number = Constants.TruncationText.length + Constants.EllipsisText.length;

    if (maxLength <= insertLengths) {
      if (maxLength <= Constants.EllipsisText.length) {
        // Unable to truncate so we just return the value
        return value;
      }

      // Return truncation with only ellipsis without <TRUNCATION> prefix
      return value.substring(0, maxLength - Constants.EllipsisText.length) + Constants.EllipsisText;
    }

    return Constants.TruncationText + value.substring(0, maxLength - insertLengths) + Constants.EllipsisText;
  }

  static getLimitedString(value: string, maxLength: number, message: string) {
    if (value.length > maxLength) {
      Utilities.logWarning(message, maxLength);
      return Utilities.truncateString(value, maxLength);
    } else {
      return value;
    }
  }

  // There are locations in the OSF code where messages are logged using this AppTelemetry that may be relevant to the converter
  // This defines it so that we will get those messages.
  static setUpOSFAppTelemetry(): void {
    if (Utilities.isNullOrUndefined(OSF["AppTelemetry"])) {
      OSF["AppTelemetry"] = {};
      OSF["AppTelemetry"]["logAppCommonMessage"] = function (message: string) {
        Utilities.log(message);
      };
    }
  }

  static async promiseAll(promises: Promise<void>[], resolve: any, reject: any, message: string) {
    let failedPromises: Error[] = [];
    await Promise.all(
      promises.map((p) =>
        p.catch((e) => {
          failedPromises.push(e);
        }),
      ),
    );

    if (failedPromises.length > 0) {
      reject(new Error(message)); //rejecting with first error
    } else {
      resolve();
    }
  }
}
